import { Box, Container, Typography } from "@mui/material";
import HomeNavbar from "../components/home-nav-bar";
import Footer from "../components/footer";

function AboutUs() {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <HomeNavbar />

      <Container maxWidth="md" sx={{ py: 6, flexGrow: 1 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          About Us
        </Typography>
        <Typography>
          The West African Journal of Life Sciences is a multidisciplinary journal dedicated to scientific research in West Africa. Established in 2023 by the Faculty of Life Sciences at Ambrose Alli University, Ekpoma, Nigeria, the journal's mission is to advance knowledge through the publication of high-quality articles that meet global standards and adhere to publication ethics.
        </Typography>
      </Container>

      <Footer />
    </Box>
  );
}

export default AboutUs;
